// extracted by mini-css-extract-plugin
export var boxItems = "_1p-1";
export var button = "_1p-5";
export var filterGroupBox = "_1p-0";
export var icon = "_1p-2";
export var iconSecondary = "_1p-4";
export var iconWrapper = "_1p-3";